import React from 'react'
import Logo from '../Assets/logo.png'
import PersonIcon from '../Assets/personIcon.svg'
import FireIcon from "../Assets/fireIcon.svg"
import LinkedInIcon from "../Assets/linkedInIcon.svg"
import TwitterIcon from "../Assets/twitterIcon.svg"
import DribbleIcon from "../Assets/dribbleIcon.svg"

export default function Footer () {
    return(
        <div className='flex items-center justify-center mt-24 mb-10'>
            <div className='w-11/12'>
                <div className='flex items-center justify-between'>
                    <div>
                        <img className='w-[7.6rem] h-[2.25]' src={Logo} /> 
                    </div>
                </div>
                <div className='w-full h-[1.5px] bg-[#E5E7EB] mt-8'></div>
                <div className='mt-7'>
                    <p className='text-[1rem] text-[#6B7280]'>© 2023 DAIMLAS. All rights reserved.</p>
                </div>
            </div>
        </div>
    );
}